import { render, staticRenderFns } from "./FootnoteDisplay.vue?vue&type=template&id=4eb75a36&scoped=true&"
import script from "./FootnoteDisplay.vue?vue&type=script&lang=js&"
export * from "./FootnoteDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FootnoteDisplay.vue?vue&type=style&index=0&id=4eb75a36&prod&lang=scss&"
import style1 from "./FootnoteDisplay.vue?vue&type=style&index=1&id=4eb75a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb75a36",
  null
  
)

export default component.exports